import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.athleteGenders;
export const athleteGendersSelector = (state: RootState) => getState(state).data;
export const athleteGendersIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const athleteGendersIsReadySelector = (state: RootState) => getState(state).isReady;
export const athleteGendersErrorSelector = (state: RootState) => getState(state).error;
